import { render, staticRenderFns } from "./AnesthetiaForm.vue?vue&type=template&id=d9d64f2c&scoped=true"
import script from "./AnesthetiaForm.vue?vue&type=script&lang=js"
export * from "./AnesthetiaForm.vue?vue&type=script&lang=js"
import style0 from "./AnesthetiaForm.vue?vue&type=style&index=0&id=d9d64f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d64f2c",
  null
  
)

export default component.exports